import { render } from "./Reservations.vue?vue&type=template&id=33ef463e&ts=true"
import script from "./Reservations.vue?vue&type=script&lang=ts"
export * from "./Reservations.vue?vue&type=script&lang=ts"

import "./Reservations.vue?vue&type=style&index=0&id=33ef463e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__